module.exports = __webpack_public_path__ + "static/media/VWG_BANNER.1d96e861.png";